import { startCase } from "lodash";
import { ConsentPrefillSource } from "@/pages/app/provider/consent-forms/ccm-consent/ccm-consent-types";
import {
  firstEmergencyContact,
  lockConsentFields,
  toConsentDate,
  toConsentLabel,
  toConsentPhone,
  toConsentStreet,
  toContactName,
} from "@/pages/app/provider/consent-forms/ccm-consent/ccm-consent-utils";
import {
  PATIENT_CONSENT_INITIAL_VALUES,
  PATIENT_FIELDS,
  PREFILLED_PATIENT_FIELD_NAMES,
} from "./patient-consent-constant";
import { PatientConsentFormValues } from "./patient-consent-types";

export const LOCKED_PATIENT_FIELDS = lockConsentFields(
  PATIENT_FIELDS,
  PREFILLED_PATIENT_FIELD_NAMES
);

export const buildPatientConsentPrefill = (
  source: ConsentPrefillSource
): PatientConsentFormValues => ({
  ...PATIENT_CONSENT_INITIAL_VALUES,
  patient: {
    ...PATIENT_CONSENT_INITIAL_VALUES.patient,
    patientName: [source.firstName, source.lastName]
      .filter((name) => name?.trim())
      .join(" "),
    dateOfBirth: toConsentDate(source.birthDate),
    gender: startCase(source.sex?.toLowerCase() ?? ""),
    address: [
      toConsentStreet(source),
      source.address?.city,
      source.address?.state,
      source.address?.zipcode,
    ]
      .filter((part) => part?.trim())
      .join(", "),
    phone: toConsentPhone(source),
    emergencyContact: toContactName(firstEmergencyContact(source)),
    relationship: toConsentLabel(
      firstEmergencyContact(source)?.relationshipWithPatient
    ),
  },
});
